(function (angular) {
	'use strict';

	angular
		.module('marketingModule')
		.controller('SelectServiceLevel', [
			'globalConfig',
			'orderFormFactory',
			'urlFactory',
			SelectServiceLevelFunction
		]);

	function SelectServiceLevelFunction(
		globalConfig,
		orderFormFactory,
		urlFactory
	) {
		var selectServiceLevel = this;

		selectServiceLevel.handleSelect = function(serviceLevel) {
			if(serviceLevel === 'STARTER') {
				orderFormFactory.submitOrderForm(selectServiceLevel.starterPortfolioRiaPlanId, serviceLevel).then(function() {
					urlFactory.redirect('/reits/checkout/start');
				});
			} else if(serviceLevel === 'CORE') {
				urlFactory.redirect('/start-investing-sl/core-plans');
			} else if(serviceLevel === 'ADVANCED') {
				urlFactory.redirect('/start-investing-sl/advanced-plans');
			}
		};

		selectServiceLevel.$onInit = function() {
			angular.extend(selectServiceLevel, globalConfig);
		};

	}
})(window.angular);